<!-- Apple Settings Form -->
<form [formGroup]="appleSettingsForm" autocomplete="off" id="appleSettingsWrapper" novalidate>

  <!-- Single Unified Card for all Apple fields -->
  <div class="card">
    <!-- Header Card -->
    <div class="header-card">
      <div class="header-left">
        <p class="header-title">{{ 'Apple Distribution Settings' | translate }}</p>
        <p class="header-sub">{{ 'Configure your Apple credentials and generate your iOS app build for the App Store.' | translate }}</p>
      </div>
      <div class="header-right">
        <button class="submit-btn" type="button" (click)="saveSettings()" [disabled]="saving">
          <mat-icon>save</mat-icon>
          <span>{{ 'Save Settings' | translate }}</span>
        </button>
      </div>
    </div>
    <!-- Apple Details Section -->
    <div class="subCard">
      <div class="sub-card-title">{{ 'Apple Details' | translate }}</div>
      <div class="fields-grid">
        <!-- Apple Key ID -->
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Apple Key ID' | translate }}</label>
            <a href="https://appstoreconnect.apple.com/access/integrations/api" target="_blank">
              {{ 'Get from Here' | translate }}
              <img src="assets/icons/External_link.svg" [alt]="'External link' | translate" />
            </a>
          </div>
          <input class="field-input" type="text" [placeholder]="'ABCD98765E' | translate" formControlName="key_id" [value]="appleSettingsData?.key_id | trim" />
        </div>
        <!-- Apple Issuer ID -->
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Apple Issuer ID' | translate }}</label>
            <a href="https://appstoreconnect.apple.com/access/integrations/api" target="_blank">
              {{ 'Get from Here' | translate }}
              <img src="assets/icons/External_link.svg" [alt]="'External link' | translate" />
            </a>
          </div>
          <input class="field-input" type="text" [placeholder]="'1321wer-6545-7894-aasa-9876543ab123' | translate" formControlName="issuer_id" [value]="appleSettingsData?.issuer_id | trim" />
        </div>
        <!-- Team Name -->
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Team Name' | translate }}</label>
            <a href="https://developer.apple.com/account/#!/membership/" target="_blank">
              {{ 'Get from Here' | translate }}
              <img src="assets/icons/External_link.svg" [alt]="'External link' | translate" />
            </a>
          </div>
          <input class="field-input" type="text" [placeholder]="'John Doe' | translate" formControlName="team_name" [value]="appleSettingsData?.team_name | trim" />
        </div>
        <!-- Team ID -->
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Team ID' | translate }}</label>
            <a href="https://developer.apple.com/account/#!/membership/" target="_blank">
              {{ 'Get from Here' | translate }}
              <img src="assets/icons/External_link.svg" [alt]="'External link' | translate" />
            </a>
          </div>
          <input class="field-input" type="text" [placeholder]="'A1BC23456D' | translate" formControlName="team_id" [value]="appleSettingsData?.team_id | trim" />
        </div>
      </div>
      <!-- Store Credentials Section -->
      <div class="sub-card-title">{{ 'Store Credentials' | translate }}</div>
      <div class="fields-grid">
        <!-- iTunes Email (Full Width) -->
        <div class="field-wrapper full-width-field">
          <div class="field-label-row">
            <label>{{ 'iTunes Email' | translate }}</label>
            <a href="https://appleid.apple.com/" target="_blank">
              {{ 'Get from Here' | translate }}
              <img src="assets/icons/External_link.svg" [alt]="'External link' | translate" />
            </a>
          </div>
          <input class="field-input" type="email" [placeholder]="'info@yourwebsite.com' | translate" autocomplete="off" formControlName="email" [value]="appleSettingsData?.email | trim" />
        </div>
        <!-- App-specific Password -->
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'App-specific Password' | translate }}</label>
          </div>
          <input class="field-input" type="text" [placeholder]="'abcd-efgh-ijkl-mnop' | translate" formControlName="app_specific_pass" [value]="appleSettingsData?.app_specific_pass | trim" />
        </div>
        <!-- iTunes Password -->
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'iTunes Password' | translate }}</label>
          </div>
          <input class="field-input" type="password" placeholder="" autocomplete="new-password" formControlName="itunes_password" [value]="appleSettingsData?.itunes_password | trim" />
        </div>
        <!-- p8 Key File Upload -->
        <div class="field-wrapper upload-wrapper">
          <div class="field-label-row">
            <label>{{ 'p8 Key File' | translate }}</label>
            <a href="https://appstoreconnect.apple.com/access/integrations/api" target="_blank">
              {{ 'Get from Here' | translate }}
              <img src="assets/icons/External_link.svg" [alt]="'External link' | translate" />
            </a>
          </div>
          <div class="upload-area" *ngIf="!appleSettingsData.key_filepath">
            <input type="file" formControlName="key_filepath" id="key_filepath" (change)="processFile($event, 'application/pkcs8', 'key_filepath')" accept="application/pkcs8,.p8" />
            <div class="upload-icon-circle">
              <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3.33301" y="3.33398" width="40" height="40" rx="20" fill="#ECF5F8" />
                <rect x="3.33301" y="3.33398" width="40" height="40" rx="20" stroke="#F9FAFB" stroke-width="6.66667" />
                <path
                  d="M20 26.6673L23.3333 23.334M23.3333 23.334L26.6667 26.6673M23.3333 23.334V30.834M30 27.2863C31.0179 26.4457 31.6667 25.1739 31.6667 23.7507C31.6667 21.2193 29.6146 19.1673 27.0833 19.1673C26.9012 19.1673 26.7309 19.0723 26.6384 18.9154C25.5517 17.0713 23.5454 15.834 21.25 15.834C17.7982 15.834 15 18.6322 15 22.084C15 23.8057 15.6962 25.3649 16.8225 26.4953"
                  stroke="url(#paint0_linear_3029_40085)"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <defs>
                  <linearGradient id="paint0_linear_3029_40085" x1="23.8178" y1="41.8996" x2="20.7349" y2="16.145" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#7CEEE6" />
                    <stop offset="0.495192" stop-color="#3A95B9" />
                    <stop offset="0.990385" stop-color="#004691" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div class="upload-text">{{ 'click to Upload' | translate }}</div>
            <div class="upload-hint">{{ 'AuthKey_XXXXXXXXX.p8 file from Apple Developer Portal' | translate }}</div>
          </div>
          <div *ngIf="builderService.showUpdateProgress && !appleSettingsData.key_filepath" class="upload-progress">
            <div class="spinner-ring-sm"></div>
            <span>{{ 'Uploading file...' | translate }}</span>
          </div>
          <div *ngIf="appleSettingsData.key_filepath" class="insertedFile">
            <img src="assets/images/file.png" [alt]="'file icon' | translate" />
            <h3>{{ appleSettingsData.key_filepath }}</h3>
            <span (click)="removeFile('appleSettingsData.key_filepath')">✕</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<!-- IOS Build Form -->
<form [formGroup]="iosBuildForm" id="iosBuildWrapper" class="page-wrapper" (ngSubmit)="onSubmit()">
  <!-- iOS Version Card (shown when not building) -->
  <div class="card" *ngIf="(!buildStart || value == 100 || error) && !checkingStatus" [class.section-disabled]="!appleSettingsFilled">
    <div class="section-heading">
      <h3>{{ 'iOS Build Settings' | translate }}</h3>
    </div>
    <div class="field-wrapper" style="max-width: 100%;">
      <label class="field-label" for="iosVersion">{{ 'IOS Version' | translate }}</label>
      <input
        class="field-input"
        id="iosVersion"
        placeholder="0"
        type="number"
        min="0.1"
        step="0.1"
        formControlName="iosVersion"
      />
      <span class="field-hint">{{ 'Format example: 1.0 or 1.1' | translate }}</span>
    </div>
  </div>

  <!-- Checking Status -->
  <div class="card status-card" *ngIf="checkingStatus && !error">
    <div class="spinner-ring"></div>
    <p class="status-text">{{ 'Checking Build Status' | translate }}</p>
  </div>

  <!-- Building In Progress -->
  <div class="card status-card" *ngIf="buildStart && !checkingStatus && !error && value < 100">
    <div class="progress-circle-wrap">
      <svg class="progress-circle" viewBox="0 0 80 80">
        <circle class="progress-track" cx="40" cy="40" r="34"/>
        <circle
          class="progress-fill"
          cx="40" cy="40" r="34"
          [style.stroke-dashoffset]="213.6 - (213.6 * value / 100)"
        />
      </svg>
      <span class="progress-label">{{ value }}%</span>
    </div>
    <button class="btn-generate generating" type="button" disabled>
      <span class="material-icons-outlined">auto_fix_high</span>
      {{ 'Generating iOS...' | translate }}
    </button>
    <p class="dont-close">{{ "please don't close this window" | translate }}</p>
  </div>

  <!-- Success State -->
  <div class="card success-card" *ngIf="value == 100 && buildStart && !checkingStatus && !error">
    <div class="success-left">
      <div class="success-top">
        <span class="material-icons-outlined success-icon">check_circle</span>
        <p class="success-title">{{ 'Ios Application Uploaded Successfully to your ITunes Account' | translate }}</p>
        <p class="success-sub">{{ 'After few minutes you will find your app ready for submission on your Itunes Account' | translate }}</p>
      </div>
      <div class="success-actions">
        <button type="button" class="btn-rebuild-outline" (click)="rebuildApp()">
          {{ 'Rebuild App' | translate }}
        </button>
      </div>
    </div>
    <div class="success-right" *ngIf="qrLink">
      <img [src]="qrLink" [alt]="'QR Code' | translate" class="qr-image" />
      <p class="qr-label">{{ 'you can download directly' | translate }}<br/>{{ 'from scan this QR Code' | translate }}</p>
    </div>
  </div>

  <!-- Error State -->
  <div class="card error-card" *ngIf="error">
    <span class="material-icons-outlined error-icon">error_outline</span>
    <p class="error-msg" *ngIf="buildErrorMsg && buildErrorMsg !== ''">{{ buildErrorMsg }}</p>
    <p class="error-msg" *ngIf="!buildErrorMsg || buildErrorMsg === ''">
      {{ 'Error occured while building' | translate }}<br/>
      {{ 'please try again' | translate }}<br/>
      {{ 'If the error persists then contact the customer support' | translate }}
    </p>
    <button type="button" class="btn-rebuild" (click)="rebuildApp()">
      {{ 'Rebuild App' | translate }}
    </button>
  </div>

  <!-- Generate Button -->
  <div *ngIf="(!buildStart || value == 100 || error) && !checkingStatus" class="generate-btn-wrap">
    <button class="btn-generate" type="submit" [disabled]="!appleSettingsFilled || saving">
      <span class="material-icons-outlined">auto_fix_high</span>
      {{ 'Generate iOS App' | translate }}
    </button>
  </div>

</form>
